<template>
    <div class='tab'>
        <div class='tab-options'>
            <div :class="{'item-active' : tab === 'content'}" class='options-item' @click="changeTab('content')">
                <span>内容</span>
            </div>
            <div :class="{'item-active' : tab === 'style'}" class='options-item' @click="changeTab('style')">
                <span>样式</span>
            </div>
            <div :class="{'bgc-active': tab === 'style'}" class='options-bgc'></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tab: 'content'
        };
    },
    methods: {
        changeTab(e) {
            this.tab = e;
            this.$emit('getTab', e);
        }
    }
};
</script>

<style lang='scss' scoped>
.tab {
    width: 100%;
    .tab-options {
        position: relative;
        width: 100%;
        height: 30px;
        border-radius: 15px;
        background-color: #f2f2f2;
        overflow: hidden;
        display: flex;

        .options-item {
            flex: 1;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            z-index: 1;
        }

        .item-active {
            color: #fff;
        }

        .options-bgc {
            position: absolute;
            width: 50%;
            height: 100%;
            background-color: #409EFF;
            transition: transform .3s;
            transform: translateX(0);
        }

        .bgc-active {
            transform: translateX(100%);
        }
    }
}
</style>